module.exports = __webpack_public_path__ + "static/media/Yeongwol5.bd90521b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Surroundings/assets/Yeongwol5.jpeg
// module id = 587
// module chunks = 0